import clsx from "clsx";
import { useQueryState } from "nuqs";
import { useState } from "react";

import { formatDateLocaleMonth } from "@transfr-inc/dashboard-components/utils";

import { FeedbackButton } from "@components/feedback-button";
import { productParser } from "@lib/utils/search-params-parsers";
import { useCurrentUser } from "@src/hooks/queries/account";
import { useFeatures, useProducts } from "@src/hooks/queries/account-selectors";
import { useOrganizationDetails } from "@src/hooks/queries/organization";
import { RosterModal } from "@views/users/roster/roster-modal";

import { DashboardHeader, OrgsShortcuts, UploadFooter } from "./components";
import { ProductTabs } from "./views/multi-org/product.tabs";

import "./dashboard.scss";

export default ({ className, responsiveStyles = {} }) => {
  const currentUser = useCurrentUser();
  const products = useProducts();
  const features = useFeatures();
  const { firstName, organizationName, organizationCode } = currentUser || {};
  const { data: organization } = useOrganizationDetails(organizationCode);
  const [openRosterModal, setOpenRosterModal] = useState();
  const { canCreateUser } = features;
  const [selectedProductTab] = useQueryState("product", productParser());

  return (
    <div className={clsx("dashboard", className)}>
      <div className="dashboard-container">
        <DashboardHeader
          title={
            <div className="dashboard-title-container">
              <span>Dashboard</span>
              <FeedbackButton productId={selectedProductTab} />
            </div>
          }
          subtitle={
            <div>
              Hi <strong>{firstName}</strong>! Here&apos;s your{" "}
              <strong>{organizationName}</strong> update for{" "}
              {formatDateLocaleMonth()}.
            </div>
          }
        ></DashboardHeader>
        <ProductTabs
          products={products}
          professionalLearning={organization?.professionalLearning}
        />
        {canCreateUser && (
          <UploadFooter setOpenRosterModal={setOpenRosterModal} />
        )}
      </div>
      <div className="side-shortcuts">
        <OrgsShortcuts></OrgsShortcuts>
      </div>
      <RosterModal
        onClose={() => setOpenRosterModal(false)}
        show={openRosterModal}
        responsiveStyles={responsiveStyles}
      ></RosterModal>
    </div>
  );
};
